import { render, staticRenderFns } from "./PayMessage.vue?vue&type=template&id=ff0c401e&web=true&"
import script from "./PayMessage.vue?vue&type=script&lang=js&"
export * from "./PayMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports